import { useSelector } from "react-redux";
import { IStore } from '../interfaces/IStore';
import { IEconomicCalendarState } from '../reducers/economicCalendarReducer';

export const useEconomicCalendarData = (): IEconomicCalendarState => useSelector((state: IStore) => ({
  data: state.economicCalendar.data,
  countries: state.economicCalendar.countries,
  selectedCountry: state.economicCalendar.selectedCountry,
  selectedImpactLevel: state.economicCalendar.selectedImpactLevel,
}));

